import request from '@/utils/request'
import { formatParam } from '@/utils/tool'
import { getAllSizeRequest } from './live'
interface productSearchType {
  areaId?: string | number; // 地区ID
  autoCount?: boolean; // 数据是否拿分页
  dbLink?: string; // 所属saas
  isSupmarket?: number; // 是否精品超市 1 是
  keyword?: string; // 搜索关键字
  key?: string; // 搜索关键字
  maxPrice?: string | number; // 最大金额
  minPrice?: string | number; // 最小金额
  page?: number; // 页码
  parentMchId?: string | number;
  resultNum?: number; // 每页的数据
  sort?: string | number; // 筛选条件 具体看接口文档，不同接口sort值不一样
  sortType?: string | number; // 排序方式 1升序 0 降序
  tagIds?: string; // 标签ID 多个用, 分开
  treeId?: string | number; // treeId
  themeId?: string | number; // 主题编号筛选
  latitude?: string | number; // 经度
  longitude?: string | number; // 纬度
}

// 全球货仓产品列表查询，treeId对应根据custProductTypies接口返回的id来对应
export function productSearch (params: productSearchType): any {
  return request(`/saas/gtpw/product/search?${formatParam(params)}`)
}

// 全球货仓美食频道主题
export function foodsThemes (params: productSearchType): any {
  return request(`/openapi/product/themes?${formatParam(params)}`)
}

// 美食权益产品列表
export function foodsProducts (params: productSearchType): any {
  return getAllSizeRequest('/saas/gtpw/product/foodProducts', params)
}

// 全球货仓产品列表查询
export function products (params: productSearchType): any {
  return getAllSizeRequest('/saas/gtpw/product/lark/products', params)
}

// 获取产品数量 获取产品数据 商户中心 底部统计数据
export function countProduct (): any {
  return request('/saas/gtpw/product/countProduct')
}

// 我的产品列表 商户中心
export function productList (params): any {
  return request(`/saas/gtpw/product/productList?${formatParam(params)}`)
}

// 获取产品分类和标签
export function listLabeltag (params): any {
  return request(`/saas/gtpw/product/listLabeltag?${formatParam(params)}`)
}

// 上周爆款
export function weekHot (params: {
  parentMchId: number
}): any {
  return request(`/saas/gtpw/product/weekHot?${formatParam(params)}`)
}

// 热销产品列表
export function hotSale (params: {
  areaId?: number | string;
  autoCount?: boolean;
  keywords?: string;
  page: number;
  parentMchId: number | string;
  resultNum: number | string;
  sort?: number | string;
  treeId?: number | string;
}): any {
  return request(`/saas/gtpw/product/hotSale?${formatParam(params)}`)
}

// 获取产品标签分类
export function listLabel (params: {
  labelType: number | string
}): any {
  return request(`/saas/gtpw/product/listLabel?${formatParam(params)}`)
}

// 得到一级分类的标签
export function listOneLabel (params: {
  labelId: number
}): any {
  return request(`/saas/gtpw/product/listOneLabel?${formatParam(params)}`)
}

// 得到所有二级分类的标签
export function listTwoTag (params: {
  tagId: number | string
}): any {
  return request(`/saas/gtpw/product/listTwoTag?${formatParam(params)}`)
}

// 获取景区列表
export function scenicList (params: {
  keyword: string;
  page: number;
  autoCount?: boolean;
  resultNum: number | string;
  sort: number;
  state: number;
}): any {
  return request(`/saas/gtpw/product/scenic/list?${formatParam(params)}`)
}

// 全球货仓景点产品列表查询
export function scenicProductList (params: {
  page: number;
  autoCount?: boolean;
  resultNum: number | string;
  sort: number;
  sortType: number;
  treeId: number;
}): any {
  return request(`/saas/gtpw/product/scenic/productList?${formatParam(params)}`)
}
